import { Component, Input } from '@angular/core';
import { AbstractComponentMobile } from '../../abstract/abstract-component-global.directive';

import { FadingSpanComponent } from '../fading-span/fading-span.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'web-battery-transfer',
    templateUrl: './battery-transfer.component.html',
    styleUrls: ['./battery-transfer.component.scss'],
    imports: [FadingSpanComponent, TranslateModule],
})
export class BatteryTransferComponent extends AbstractComponentMobile {
    public override tag = '[BatteryTransferComponent]';

    @Input()
    value?: number;

    @Input()
    suffix?: string;
}
